module.exports = __webpack_public_path__ + "img/avatar.f4f3af1e.png";